<script>
    import { resourcesPath } from "../../stores.js";
    import Bars from "./Bars.svelte";
</script>


<header id="brak-header">
    <Bars />

    <a href="https://www.brak.de" aria-label="Logo: Bundesrechtsanwaltskammer - zur Internetseite" rel="noreferrer" target="_blank">
        <img src={`${$resourcesPath}/img/logo_brak.svg`} alt="Logo: Bundesrechtsanwaltskammer - zur Internetseite" class="brak-logo"/>
    </a>
</header>

<style>
    .brak-logo {
        margin-top: var(--brak-logo-margin-top);
        height: var(--brak-logo-height);
    }
</style>